/** Primary casino entry — Lotus-style lobby tab. */
export const MAIN_CASINO_PATH = '/casino-int/tab/1'

export const LOTUS_CASINO_FAVORITES_PATH = `${MAIN_CASINO_PATH}?view=favorites`

export const LOTUS_PROVIDERS_PATH = '/casino-int/providers'

export const isMainCasinoPath = (pathname: string): boolean =>
  pathname === '/casino-int/tab/1' || pathname.startsWith('/casino-int/tab/1?')
